export default __webpack_public_path__ + "static/media/banner-top-desk2.19326d38.png";